// Cấu hình quyền dùng ở FE
// Giữ đồng bộ với backend (permission.constants.ts)

export const PERMISSIONS = {
    ADMIN: {
        ALL: 'SHOP_ALL',
    },
    CUSTOMER: {
        VIEW: 'CUSTOMER_VIEW',
        DETAIL: 'CUSTOMER_DETAIL',
        CREATE: 'CUSTOMER_CREATE',
        UPDATE: 'CUSTOMER_UPDATE',
        DELETE: 'CUSTOMER_DELETE',
        CHECKIN: 'CUSTOMER_CHECKIN',
        VIEW_PHONE: 'CUSTOMER_VIEW_PHONE',
    },
    BILL: {
        VIEW_LIST: 'BILL_VIEW_LIST',
        VIEW_DETAIL: 'BILL_VIEW_DETAIL',
        CREATE: 'BILL_CREATE',
        UPDATE: 'BILL_UPDATE',
        DELETE: 'BILL_DELETE',
    },
    SERVICE: {
        VIEW_LIST: 'SERVICE_VIEW_LIST',
        VIEW_DETAIL: 'SERVICE_VIEW_DETAIL',
        CREATE: 'SERVICE_CREATE',
        UPDATE: 'SERVICE_UPDATE',
        DELETE: 'SERVICE_DELETE',
    },
    ATTRIBUTE: {
        VIEW: 'ATTRIBUTE_VIEW',
        CREATE: 'ATTRIBUTE_CREATE',
        UPDATE: 'ATTRIBUTE_UPDATE',
        DELETE: 'ATTRIBUTE_DELETE',
    },
    COMMISSION: {
        VIEW: 'COMMISSION_VIEW',
        CREATE: 'COMMISSION_CREATE',
        UPDATE: 'COMMISSION_UPDATE',
        DELETE: 'COMMISSION_DELETE',
    },
    REPORT: {
        DASHBOARD_VIEW: 'REPORT_DASHBOARD_VIEW',
        CUSTOMER_VIEW: 'REPORT_CUSTOMER_VIEW',
        REVENUE_VIEW: 'REPORT_REVENUE_VIEW',
        END_DAY_VIEW: 'REPORT_END_DAY_VIEW',
        SALES_VIEW: 'REPORT_SALES_VIEW',
        SALES_DETAIL_VIEW: 'REPORT_SALES_DETAIL_VIEW',
        REVENUE_BILL_DETAIL_VIEW: 'REPORT_REVENUE_BILL_DETAIL_VIEW',
        EXPORT_REVENUE_BILL: 'REPORT_EXPORT_REVENUE_BILL',
    },
    REVENUE_BOOK: {
        VIEW: 'REVENUE_BOOK_VIEW',
        EXPORT: 'REVENUE_BOOK_EXPORT',
    },
    FEEDBACK: {
        UPDATE_QR_STATUS: 'FEEDBACK_UPDATE_QR_STATUS',
        VIEW: 'FEEDBACK_VIEW',
        UPDATE: 'FEEDBACK_UPDATE',
        DELETE: 'FEEDBACK_DELETE',
    },
    EMPLOYEE: {
        VIEW: 'EMPLOYEE_VIEW',
        DETAIL: 'EMPLOYEE_DETAIL',
        CREATE: 'EMPLOYEE_CREATE',
        UPDATE: 'EMPLOYEE_UPDATE',
        DELETE: 'EMPLOYEE_DELETE',
    },
    SALARY: {
        VIEW: 'SALARY_VIEW',
        EXPORT: 'SALARY_EXPORT',
    },
    SHIFT_WORK: {
        VIEW: 'SHIFT_WORK_VIEW',
        CREATE: 'SHIFT_WORK_CREATE',
        UPDATE: 'SHIFT_WORK_UPDATE',
        DELETE: 'SHIFT_WORK_DELETE',
    },
    BOOKING: {
        VIEW: 'BOOKING_VIEW',
        CREATE: 'BOOKING_CREATE',
        UPDATE: 'BOOKING_UPDATE',
        CANCEL: 'BOOKING_CANCEL',
        BULK_SCHEDULE: 'BOOKING_BULK_SCHEDULE',
    },
    PACKAGE: {
        SELL_OVERRIDE: 'PACKAGE_SELL_OVERRIDE',
    },
};

export const ALL_PERMISSION_CODES = Object.values(PERMISSIONS).flatMap((group) => Object.values(group));
